import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/crm/AppShell";
import { LiveQueue } from "@/components/crm/LiveQueue";

export const Route = createFileRoute("/_authenticated/atendimento")({
  component: AtendimentoPage,
});

/**
 * O painel ao vivo em tela cheia.
 *
 * Saiu do menu quando virou uma visão dentro de Conversas — dois itens para o
 * mesmo assunto fazem a pessoa perguntar onde olhar. A rota continua de pé por
 * dois motivos concretos: links salvos e favoritos não podem quebrar, e uma
 * central com mais gente vai querer esta tela aberta sozinha numa segunda tela,
 * sem a caixa de entrada em volta.
 *
 * Altura fixa: o cabeçalho fica parado e o painel rola por dentro, como toda
 * tela de trabalho contínuo.
 */
function AtendimentoPage() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <PageHeader title="Atendimento" description="Quem está esperando agora" />
      <LiveQueue />
    </div>
  );
}
